import React, { useState, useEffect } from 'react';
import isValidUrl from './components/helpers/isValidUrl';
import isInteger from './components/helpers/isInteger';
import getQueryStringValue from './components/helpers/getQueryStringValue';
// import HHPlayer2 from './components/newPlayer/HHPlayer2';
import Loader from './components/Loader';
// import Parser from 'rss-parser';
import Parser from './parser/rssParser'
import TWHHPlayer from './components/newPlayer/TWHHPlayer';
import { fetchPodcastId } from './components/helpers/utils';
let parser = new Parser();
// const CORS_PROXY = "https://cors-anywhere.hubhopper.com/"

function App() {
	const [podcast, setPodcast] = useState(false);
	const [rss, setRss] = useState('');

	const [error, setError] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	// const [order, setOrder] = useState('desc');
	const [platforms, setPlatforms] = useState([])
	const [chosenEpisode, setChosenEpisode] = useState(null);
	const [chosenEpisodeId, setChosenEpisodeId] = useState(null);

	const [onlyEpisode, setOnlyEpisode] = useState(false);
	const [isDark, setIsDark] = useState(false);
	const [isLogo, setLogo] = useState(true)
	const [playlist, setPlaylist] = useState(null)
	const [height, setHeight] = useState(false);
	const [themeColor, setThemeColor] = useState(null)
	const [headingFont, setHeadingFont] = useState('default')
	const [bodyFont, setBodyFont] = useState('default')
	const [isSerial, setSerial] = useState(false)


	const episodesToShow = (episodes) => {
		if (playlist && playlist.length > 0) {
			return episodes.filter((episode, _) => {
				var id = episode.link.split("/").filter(Boolean).pop();
				return playlist.includes(parseInt(id))
			})
		} else {
			return episodes
		}
	}
	// const [episodeArr, setEpisodeArr] = useState([]);

	// IMPORTANT: this format is handled for old users.
	const getParamsFromFormat1 = () => {
		const isCustomPlaylist = getQueryStringValue('isCustom') === 'true';
		const feed = window.location.pathname.split("/")[1]
		if (feed == undefined || feed == null) {
			throw new Error("Feed not Found")
		}
		let url = ''
		if (isCustomPlaylist) {
			// feed contains
			// podcast rss is on 0th index
			// custom playlist is starts from 1->n with episode ids
			let list = JSON.parse(atob(feed))
			url = list[0]
			setPlaylist(list.slice(1))
		}
		else {
			// podcast rss in feed
			url = atob(feed)
		}
		// let orderParam = getQueryStringValue('order');
		// if (orderParam === 'asc') { setOrder(orderParam) }

		const chosenEpParam = getQueryStringValue('episode');
		if (chosenEpParam && isInteger(chosenEpParam)) { setChosenEpisode(chosenEpParam) }

		const chosenEpIdParam = getQueryStringValue('episodeId');
		if (chosenEpIdParam && isInteger(chosenEpIdParam)) { setChosenEpisodeId(chosenEpIdParam) }


		const onlyEpParam = getQueryStringValue('onlyEpisode');
		const isDarkParam = getQueryStringValue('isDark');
		const isLogo = getQueryStringValue('isLogo')
		// for dark and light theme
		setIsDark(isDarkParam == 'true');
		setLogo(isLogo != 'false')

		if (onlyEpParam == 'true') {
			setOnlyEpisode(onlyEpParam == 'true');
		}

		const heightParam = getQueryStringValue('height');
		if (heightParam === 'large') {
			setHeight(true);
		}
		return url
	}

	// IMPORTANT: this format is handled for new users.
	const getParamsFromFormat2 = (lastUpdated) => {
		// [ "https://feeds.hubhopper.co/51925ba579216c0a07141c10aabdd5b0.rss", false, false, true, null , "#ff0000", "default", "default" ]
		const feed = window.location.pathname.split("/")[1]
		if (feed == undefined || feed == null) {
			throw new Error("Feed not Found")
		}
		// feed contains
		// podcast rss is on 0th index
		// isDark on 1st index
		// isLogo on 2nd index
		// onlyEpisode on 3rd index
		// episodeId on 4th index
		// themecolor on 5th index
		// headingfont on 6th index
		// bodyfont on 7th index
		// custom playlist is starts from 8->n with episode ids
		let list = JSON.parse(atob(feed))
		// to get the updated rss ignoring cache for latest episodes
		let url = list[0] + (lastUpdated != '' ? `?lastUpdated=${lastUpdated}` : '')
		let isDarkParam = list[1]
		let isLogo = list[2]
		let onlyEpParam = list[3]
		let chosenEpIdParam = list[4]
		let themeColorParam = list[5]
		let headingFontParam = list[6]
		let bodyFontParam = list[7]
		if (list.length > 8) {
			setPlaylist(list.slice(8))
		}
		if (chosenEpIdParam && isInteger(chosenEpIdParam)) { setChosenEpisodeId(chosenEpIdParam) }
		if (themeColorParam) {
			setThemeColor(themeColorParam)
		}
		setHeadingFont(headingFontParam)
		setBodyFont(bodyFontParam)
		// for dark and light theme
		setIsDark(isDarkParam);
		setLogo(isLogo)
		setOnlyEpisode(onlyEpParam)
		return url
	}

	useEffect(async () => {
		try {
			// keep in mind episode listing is in descending globally
			let isFormat2 = getQueryStringValue('format') == '2';
			let lastUpdated = getQueryStringValue('lastUpdated') ?? '';

			let url = ''
			if (isFormat2) {
				url = getParamsFromFormat2(lastUpdated)
			} else {
				url = getParamsFromFormat1()
			}

			// const episodeArrParam = getQueryStringValue('list');
			// if (episodeArrParam && episodeArrParam != '') {
			// 	// %7B%0A%20%20%22episodes%22%3A%20%5B1%2C2%2C3%2C4%5D%0A%7D
			// 	let obj = decodeURIComponent(episodeArrParam);
			// 	try {
			// 		obj = JSON.parse(obj);
			// 		if (obj.episodes && Array.isArray(obj.episodes)) {
			// 			setEpisodeArr(obj.episodes);
			// 		}
			// 	} catch (e) {
			// 		console.log('Invalid custom selected list of episodes', e);
			// 	}
			// }
			async function fetchDistribution(url, podcastId) {
				const isDev = url.includes(".co/");
				try {
					var res = await fetch(`https://apis.hubhopper${isDev ? ".co/stage" : ".com/v5"}/studio/open/podcasts/${podcastId}/distribution/platforms?v=${new Date().getTime()}`
						, {
							headers: {
								"Content-Type": "application/json",
								"x-api-key": isDev ? "DdjDiUOzsC7nn0t95VTJi9CC29kb9o5A1yr6zTdk" : "9s0pBnORiaaMMCPvl1vcL3HrOJLFQ38j4bqk8Aw3"
							},
						}
					)
					const r = await res.json();
					setPlatforms(r.platforms.filter(it => it.uri != null))
				} catch (e) {
				}
			}
			async function fetchPodcast() {
				try {
					let parsedRSS = await parser.parseURL2(url);
					setSerial(parsedRSS.itunes.type.toLowerCase() == 'serial')
					setPodcast(parsedRSS)
					return parsedRSS
				} catch (e) {
					console.log("Error occurred. ", e);
					// try {
					// 	let parsedRSS = await parser.parseURL(CORS_PROXY + url);
					// 	setPodcast(parsedRSS)
					// } catch(e) {
					// 	console.log("Error occurred after proxy. ", e);
					setError(true)
					setErrorMsg('Could not fetch RSS')
					// }
					return null
				}
			}
			setRss(url)
			if (isValidUrl(url)) {
				var podcast = await fetchPodcast();
				const podcastId = fetchPodcastId(podcast.items[0].itunes.image, podcast.details.link)
				await fetchDistribution(url, podcastId)
			} else {
				setErrorMsg('Invalid Embed URL')
				setError(true)
			}
		} catch (e) {
			console.log("Error occurred. ", e);
			setError(true)
			setErrorMsg('Invalid Embed URL')
		}
	}, [])

	return (
		<div className="App flex justify-center">
			{
				!error ?
					(!podcast ? <Loader /> : <TWHHPlayer podcast={podcast} episodes={episodesToShow(podcast.items)} onlyEpisode={onlyEpisode}
						height={height} chosenEpisode={chosenEpisode} chosenEpisodeId={chosenEpisodeId}
						rss={rss} platforms={platforms} isDark={isDark} isLogo={isLogo}
						themeColor={themeColor} headingFont={headingFont} bodyFont={bodyFont}
						isSerial={isSerial}
					/>)
					:
					<div className='d-flex justify-content-center align-items-center' style={{ height: '100px' }}>
						{errorMsg === '' ? 'Could not load' : errorMsg}
					</div>
			}
		</div>
	);
}

export default App;
